<template>
  <h1 class="system_content_title">单位基本信息</h1>
  <div class="system_content_panels">
    <div
      class="systemPanel"
      style="position: relative; padding-bottom: 40px; width: 100%"
    >
      <el-form
        :model="myData.formObj"
        :rules="myData.rules"
        ref="ruleFormRef"
        :inline="true"
        label-position="top"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              style="width: 100%"
              label="单位名称（若有误，请联系技术人员修改）"
            >
              <el-input v-model="myData.formObj.name" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              style="width: 100%"
              label="统一社会信用代码（若有误，请联系技术人员修改）"
            >
              <el-input v-model="myData.formObj.orgCode" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="企业曾用名">
              <el-input
                v-model="myData.formObj.lastName"
                :disabled="myData.cid"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              style="width: 100%"
              label="行政区划（若有误，请联系技术人员修改）"
            >
              <el-input v-model="myData.formObj.regionName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              style="width: 100%"
              label="营业执照"
              prop="CompanyCard"
            >
              <el-upload
                v-model:file-list="myData.cardList"
                action="#"
                list-type="picture-card"
                :http-request="handleCardUpload"
              >
                <el-icon>
                  <Plus />
                </el-icon>
                <template #file="{ file }">
                  <div>
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url"
                      alt="图片"
                    />
                    <span class="el-upload-list__item-actions">
                      <span
                        class="el-upload-list__item-preview"
                        @click="handleCardPreview(file)"
                      >
                        <el-icon>
                          <zoom-in />
                        </el-icon>
                      </span>
                      <!-- <span class="el-upload-list__item-delete" @click="handleCardDownload(file)">
                        <el-icon>
                          <Download />
                        </el-icon>
                      </span> -->
                      <span
                        class="el-upload-list__item-delete"
                        @click="handleCardRemove(file)"
                      >
                        <el-icon>
                          <Delete />
                        </el-icon>
                      </span>
                    </span>
                  </div>
                </template>
              </el-upload>
              <el-dialog v-model="myData.dialogVisibleCard">
                <img
                  w-full
                  style="width: 100%; height: 100%"
                  :src="myData.baseUrl + myData.formObj.companyCard"
                />
              </el-dialog>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="企业照片">
              <el-upload
                v-model:file-list="myData.photoList"
                action="#"
                list-type="picture-card"
                :http-request="handlePhotoUpload"
              >
                <el-icon>
                  <Plus />
                </el-icon>
                <template #file="{ file }">
                  <div>
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url"
                      alt="图片"
                    />
                    <span class="el-upload-list__item-actions">
                      <span
                        class="el-upload-list__item-preview"
                        @click="handlePhotoPreview(file)"
                      >
                        <el-icon>
                          <zoom-in />
                        </el-icon>
                      </span>
                      <!-- <span class="el-upload-list__item-delete" @click="handlePhotoDownload(file)">
                        <el-icon>
                          <Download />
                        </el-icon>
                      </span> -->
                      <span
                        class="el-upload-list__item-delete"
                        @click="handlePhotoRemove(file)"
                      >
                        <el-icon>
                          <Delete />
                        </el-icon>
                      </span>
                    </span>
                  </div>
                </template>
              </el-upload>
              <el-dialog v-model="myData.dialogVisiblePhoto">
                <img
                  w-full
                  style="width: 100%; height: 100%"
                  :src="myData.baseUrl + myData.formObj.companyPhoto"
                />
              </el-dialog>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="单位地址" prop="Address">
              <el-input
                v-model="myData.formObj.address"
                placeholder="*必填项"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              style="width: 100%"
              label="单位联系电话"
              prop="CompanyTel"
            >
              <el-input
                v-model="myData.formObj.companyTel"
                placeholder="*必填项"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="地图（经度）">
              <el-input
                v-model="myData.formObj.xd"
                placeholder="例如：104.56735"
                type="number"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="地图（纬度）">
              <el-input
                v-model="myData.formObj.yd"
                placeholder="例如：31.53465"
                  type="number"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="法定代表人" prop="FaRen">
              <el-input v-model="myData.formObj.faRen" placeholder="*必填项" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              style="width: 100%"
              label="法定代表人手机号码（可找回账号密码）"
              prop="Telephone"
            >
              <el-input
                v-model="myData.formObj.telephone"
                placeholder="*必填项"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="环保负责人" prop="HBFZR">
              <el-input v-model="myData.formObj.hbfzr" placeholder="*必填项" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              style="width: 100%"
              label="环保负责人手机号码"
              prop="Tel"
            >
              <el-input v-model="myData.formObj.tel" placeholder="*必填项" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item style="width:100%" label="环保负责人身份证号码" prop="HBFZRIDCARD">
              <el-input v-model="myData.formObj.HBFZRIDCARD" placeholder="*必填项" />
            </el-form-item> -->
            <el-form-item style="width: 100%" label="环保负责人身份证号码">
              <el-input v-model="myData.formObj.hbfzridcard" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="企业官网">
              <el-input v-model="myData.formObj.qygw" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="联系QQ号">
              <el-input v-model="myData.formObj.qq" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="电子邮箱">
              <el-input v-model="myData.formObj.email" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="地区代码">
              <el-input v-model="myData.formObj.areaCode" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="预警体系">
              <el-input v-model="myData.formObj.yjtx" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="注册类型">
              <el-input v-model="myData.formObj.registType" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="占地面积（平方米）">
              <el-input type="number" v-model="myData.formObj.areaAcreage" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="隶属关系">
              <el-input v-model="myData.formObj.lsgx" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="产品出口">
              <el-input v-model="myData.formObj.cpck" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="管控类型" prop="gklx">
              <el-select
                style="width: 100%"
                v-model="myData.formObj.gklx"
                placeholder="请选择管控类型"
              >
                <el-option
                  v-for="(item, index) in myData.gklxList"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                  value-key="name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              style="width: 100%"
              label="排污许可管理类型"
              prop="pwlx"
            >
              <el-select
                style="width: 100%"
                v-model="myData.formObj.pwlx"
                placeholder="请选择排污许可管理类型"
              >
                <el-option
                  v-for="(item, index) in myData.pwlxList"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                  value-key="name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
           
            <el-form-item style="width:100%" label="所属街道" prop="jieDao">
              <el-select style="width:100%" filterable clearable v-model="myData.formObj.jieDao"
                placeholder="请选所属街道">
                <el-option v-for="(item, index) in myData.ssjdList" :key="index" :label="item.jieDao" :value="item.jieDao"
                  value-key="jieDao" />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item
              style="width: 100%"
              label="所属行业"
              prop="industrySelectedOptions"
            >
              <el-cascader
                style="width: 100%"
                filterable
                clearable
                v-model="myData.formObj.industrySelectedOptions"
                placeholder="*必选项"
                :options="myData.IndustryFullPathList"
                @change="handleChangeIndustry"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item style="width:100%" label="生产经营" prop="SCjy">
              <el-input v-model="myData.formObj.SCjy" placeholder="*必填项" />
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="12">
            <el-form-item style="width:100%" label="ISO14001认证">
              <el-input v-model="myData.formObj.ISO" />
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="12">
            <el-form-item style="width:100%" label="生产规模">
              <el-input v-model="myData.formObj.SCGM" />
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item style="width: 100%" label="投产日期">
              <el-date-picker
                style="width: 100%"
                v-model="myData.formObj.workDate"
                value-format="YYYY-MM-DD"
                type="date"
                placeholder="请选择投产日期"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="生产天数">
              <el-input v-model="myData.formObj.workDay" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="企业类型">
              <el-select
                style="width: 100%"
                v-model="myData.formObj.qylx"
                placeholder="请选企业类型"
              >
                <el-option
                  v-for="(item, index) in myData.qylxList"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                  value-key="Name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width: 100%" label="企业信息">
              <el-input v-model="myData.formObj.qysm" type="textarea" />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="!myData.cid">
            <el-form-item>
              <div style="display: flex; justify-content: center; width: 100%">
                <el-button
                  style="width: 200px"
                  type="primary"
                  @click="handelSave"
                  >保 存</el-button
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import {
  onMounted,
  getCurrentInstance,
  reactive,
  ref,
  nextTick,
  onBeforeUnmount,
} from "vue";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import { Plus } from "@element-plus/icons-vue";
import CONSTS from "../../store/consts";
import api from "../../http/apis";
const { proxy } = getCurrentInstance();
const ruleFormRef = ref(null);
const route = useRoute();
import { useStore } from "vuex";
const store = useStore();

// 自定义校验规则
const checkTelephone1 = (rule, value, callback) => {
  let reg = /^1[3-9]\d{9}$/;
  if (!reg.test(value)) {
    return callback(new Error(`法定代表人手机号码输入不正确`));
  } else {
    callback();
  }
};

const checkTelephone2 = (rule, value, callback) => {
  let reg = /^1[3-9]\d{9}$/;
  if (!reg.test(value)) {
    return callback(new Error(`环保负责人手机号码输入不正确`));
  } else {
    callback();
  }
};

const checkTelephone3 = (rule, value, callback) => {
  var testPhone = /^(1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8})?$/;
  var testFixedPhone = /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;
  if (!(testPhone.test(value) || testFixedPhone.test(value))) {
    return callback(new Error(`单位联系号码不正确,其中座机号以“-”分隔`));
  } else {
    callback();
  }
};

const myData = reactive({
  dialogVisibleCard: false,
  dialogVisiblePhoto: false,
  baseUrl: "http://221.10.90.153:8082",
  cardList: [],
  photoList: [],
  gklxList: [],
  pwlxList: [],
  qylxList: [],
  ssjdList: [],
  IndustryFullPathList: [],
  formObj: {},
  cid: 0,
  rules: {
    address: [{ required: true, message: "请输入单位地址", trigger: "blur" }],
    companyTel: [
      { required: true, message: "请输入单位联系电话", trigger: "blur" },
      { validator: checkTelephone3 },
    ],
    industrySelectedOptions: [
      { required: true, message: "请选择所属行业", trigger: "change" },
    ],
    faRen: [{ required: true, message: "请输入法定代表姓名", trigger: "blur" }],
    telephone: [
      { required: true, message: "请输入法人手机号码", trigger: "blur" },
      { validator: checkTelephone1 },
    ],
    hbfzr: [
      { required: true, message: "请输入环保负责人姓名", trigger: "blur" },
    ],
    tel: [
      { required: true, message: "请输入环保负责人手机号码", trigger: "blur" },
      { validator: checkTelephone2 },
    ],
    gklx: [{ required: true, message: "请选择管控类型", trigger: "change" }],
    pwlx: [
      { required: true, message: "请选择排污许可管理类型", trigger: "change" },
    ],
    jieDao: [{ required: true, message: "请选择所属街道", trigger: "change" }],
    companyCard: [
      { required: true, message: "请上传营业执照", trigger: "change" },
    ],
  },
});

onMounted(() => {
	 handleGetIndustryTree();
  handleGetQueryGKLX();
  handleGetQueryPWLX();
  handleGetQueryQYLX();
  if (Object.keys(route.query).length == 0) {
    console.info("get company id", store.state.user.userInfo);
    handleGetFormData();
  } else {
    myData.cid = route.query.cid;
    handleGetComanyByBaseCompanyId();
  }
 
});

const handleGetComanyByBaseCompanyId = async () => {
  // 通过cid获取企业信息
  const { data } = await api.companyApi.getShowByBaseCompanyId(myData.cid);

  if (data.isSuccessful) {
    myData.formObj = data.resultObj;
    myData.formObj.industrySelectedOptions = myData.formObj.sshy
      ? JSON.parse(myData.formObj.sshy)
      : "";
      if(myData.formObj.companyCard){
  myData.cardList.push({
      url: myData.baseUrl + myData.formObj.companyCard,
    });
      }
  
   if(myData.formObj.companyPhoto){
     myData.photoList.push({
      url: myData.baseUrl + myData.formObj.companyPhoto,
    });
   }
    //   handleGetQueryRegionLoadList(myData.formObj.regionName)
  } else {
    ElMessage({
      message: data.resultMsg || "[获取企业信息]未知错误，请联系管理员",
      type: "error",
      grouping: "true",
    });
  }
};

const handleGetFormData = async () => {
  // 通过用户token获取当前企业信息
  const { data } = await api.companyApi.getUserCompany();
  console.info("get company by current user", data);
  if (data.isSuccessful) {
    myData.formObj = data.resultObj;
    myData.formObj.industrySelectedOptions = myData.formObj.sshy
      ? JSON.parse(myData.formObj.sshy)
      : "";
      if(myData.formObj.companyCard){
  myData.cardList.push({
      url: myData.baseUrl + myData.formObj.companyCard,
    });
      }
  
   if(myData.formObj.companyPhoto){
     myData.photoList.push({
      url: myData.baseUrl + myData.formObj.companyPhoto,
    });
   }
    //   handleGetQueryRegionLoadList(myData.formObj.regionName)
  } else {
    ElMessage({
      message: data.resultMsg || "[获取当前用户企业]未知错误，请联系管理员",
      type: "error",
      grouping: "true",
    });
  }
};

const handleGetIndustryTree = async () => {
  // 获取所属行业
  const { data } = await api.companyApi.getIndustryTree();
  console.info("get industry tree", data);
  if (data.IsSuccessful) {
    getTreeData(data.ResultObj, myData.IndustryFullPathList);
  } else {
    ElMessage({
      message: data.resultMsg || "[获取所属行业列表]未知错误，请联系管理员",
      type: "error",
      grouping: "true",
    });
  }
};

const handleGetQueryRegionLoadList = (RegionName) => {
  // 获取所属街道
  //   proxy.$httpApi.getQueryRegionLoadList(RegionName).then(res => {
  //     if (res.IsSuccessful) {
  //       myData.ssjdList = res.ResultObj
  //     } else {
  //       ElMessage({
  //         message: res.ResultMsg,
  //         type: "error",
  //       })
  //     }
  //   })
};

const getTreeData = (data, arr) => {
  // 重构所属行业
  data.forEach((item, index) => {
    arr.push({
      value: item.id,
      label: item.text,
    });
    if (item.children.length > 0) {
      arr[index].children = [];
      getTreeData(item.children, arr[index].children);
    } else {
      delete arr[index].children;
    }
  });
};

const handleGetQueryGKLX = async () => {
  // 获取管控类型

  const { data } = await api.companyApi.getQueryGKLX();
  console.info("get gklx", data);
  if (data.isSuccessful) {
    myData.gklxList = data.resultObj;
  } else {
    ElMessage({
      message: data.resultMsg || "[获取管控类型列表]未知错误，请联系管理员",
      type: "error",
      grouping: "true",
    });
  }
  //   proxy.$httpApi.getQueryGKLX().then(res => {
  //     if (res.IsSuccessful) {
  //       myData.gklxList = res.ResultObj
  //     } else {
  //       ElMessage({
  //         message: res.ResultMsg,
  //         type: "error",
  //       })
  //     }
  //   })
};

const handleGetQueryPWLX = async () => {
  // 排污许可管理类型
  const { data } = await api.companyApi.getQueryPWLX();
  console.info("get gklx", data);
  if (data.isSuccessful) {
    myData.pwlxList = data.resultObj;
  } else {
    ElMessage({
      message:
        data.resultMsg || "[获取排污许可管理类型列表]未知错误，请联系管理员",
      type: "error",
      grouping: "true",
    });
  }
  //   proxy.$httpApi.getQueryPWLX().then(res => {
  //     if (res.IsSuccessful) {
  //       myData.pwlxList = res.ResultObj
  //     } else {
  //       ElMessage({
  //         message: res.ResultMsg,
  //         type: "error",
  //       })
  //     }
  //   })
};

const handleGetQueryQYLX = async () => {
  // 获取企业类型
  const { data } = await api.companyApi.getQueryQYLX();
  console.info("get gklx", data);
  if (data.isSuccessful) {
    myData.qylxList = data.resultObj;
  } else {
    ElMessage({
      message: data.resultMsg || "[获取企业类型列表]未知错误，请联系管理员",
      type: "error",
      grouping: "true",
    });
  }
  //   proxy.$httpApi.getQueryQYLX().then(res => {
  //     if (res.IsSuccessful) {
  //       myData.qylxList = res.ResultObj
  //     } else {
  //       ElMessage({
  //         message: res.ResultMsg,
  //         type: "error",
  //       })
  //     }
  //   })
};

const handleChangeIndustry = (value) => {
  // 选择所属行业
  myData.formObj.industrySelectedOptions = value ? value : [];
  myData.formObj.sshy = value ? JSON.stringify(value) : "";
  myData.formObj.industryId = value ? value[value.length - 1] : "";
};

const handelSave = () => {
  // 保存信息
  ruleFormRef.value.validate((valid) => {
    if (valid) {
      saveCompanyInfo(myData.formObj);
      //   proxy.$httpApi.saveCreateOrEdit(myData.formObj).then((res) => {
      //     if (res.IsSuccessful) {
      //       ElMessage({
      //         message: res.ResultMsg,
      //         type: "success",
      //       });
      //       // window.location.reload()
      //     } else {
      //       ElMessage({
      //         message: res.ResultMsg,
      //         type: "error",
      //       });
      //     }
      //   });
    } else {
      // 校验不通过自动定位到不通过的表单项
      moveToErr();
    }
  });
};
async function saveCompanyInfo(dataObj) {
  const { data } = await api.companyApi.saveCompanyInfo(dataObj);
  console.info(data);
  if (data.isSuccessful) {
    ElMessage({
      message: data.resultMsg,
      type: "success",
    });
  } else {
    ElMessage({
      message: data.resultMsg || "[保存企业信息]未知错误，请联系管理员",
      type: "error",
      grouping: "true",
    });
  }
}

const moveToErr = () => {
  nextTick(() => {
    let isError = document.getElementsByClassName("is-error");
    if (isError.length) {
      isError[0].scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
      setTimeout(() => {
        if (isError[0].querySelector("input")) {
          isError[0].querySelector("input").focus();
        }
      }, 800);
      ElMessage({
        message: "带*号为必填项，信息完整才能保存提交",
        type: "error",
      });
      return false;
    }
  });
};

const handleCardUpload = async (e) => {
  const fd = new FormData();
  fd.append("file", e.file);
  const fileData = {
    id: myData.formObj.id,
    id2: myData.formObj.baseCompanyId,
    file: fd,
  };
  const { data } = await api.companyApi.saveCard(fileData);
  if (data.IsSuccessful) {
    myData.cardList = [];
    myData.formObj.companyCard = data.ResultData;
    myData.cardList.push({
      url: myData.baseUrl + myData.formObj.companyCard,
    });
  } else {
    ElMessage({
      message: data.ResultMsg,
      type: "error",
    });
  }
  //   proxy.$httpApi.saveCard(fileData).then((res) => {
  //     if (res.IsSuccessful) {
  //       myData.cardList = [];
  //       myData.formObj.CompanyCard = res.ResultData;
  //       myData.cardList.push({
  //         url: myData.baseUrl + myData.formObj.CompanyCard,
  //       });
  //     } else {
  //       ElMessage({
  //         message: res.ResultMsg,
  //         type: "error",
  //       });
  //     }
  //   });
};

const handleCardPreview = (file) => {
  window.open(file.url);
  // myData.dialogVisibleCard = true
};

const handleCardDownload = (file) => {
  window.location.href = file.url;
};

const handleCardRemove = (file) => {
  myData.cardList = [];
  myData.formObj.CompanyCard = "";
};

const handlePhotoUpload = async (e) => {
  const fd = new FormData();
  fd.append("file", e.file);
  const fileData = {
    id: myData.formObj.id,
    id2: myData.formObj.baseCompanyId,
    file: fd,
  };
  const { data } = await api.companyApi.saveCard(fileData);
  if (data.IsSuccessful) {
    myData.photoList = [];
    myData.formObj.companyPhoto = data.ResultData;
    myData.photoList.push({
      url: myData.baseUrl + myData.formObj.companyPhoto,
    });
  } else {
    ElMessage({
      message: data.ResultMsg,
      type: "error",
    });
  }
  //   proxy.$httpApi.savePhoto(fileData).then((res) => {
  //     if (res.IsSuccessful) {
  //       myData.photoList = [];
  //       myData.formObj.CompanyPhoto = res.ResultData;
  //       myData.photoList.push({
  //         url: myData.baseUrl + myData.formObj.CompanyPhoto,
  //       });
  //     } else {
  //       ElMessage({
  //         message: res.ResultMsg,
  //         type: "error",
  //       });
  //     }
  //   });
};

const handlePhotoPreview = (file) => {
  window.open(file.url);
  // myData.dialogVisiblePhoto = true
};

const handlePhotoDownload = (file) => {
  window.location.href = file.url;
};

const handlePhotoRemove = (file) => {
  myData.photoList = [];
  myData.formObj.CompanyPhoto = "";
};
const enterSearch = (e) => {
  if (e.key == "Enter") {
    getTableData();
  }
};
window.addEventListener("keypress", enterSearch);
onBeforeUnmount(() => {
  window.removeEventListener("keypress", enterSearch);
});
</script>

<style lang="sass" scoped>
@use "../../assets/scss/companyInfo.scss" as *
</style>

<style lang="scss" scoped>
:deep(.el-upload--picture-card) {
  width: 240px !important;
  height: 240px !important;
}

:deep(.el-upload-list__item) {
  width: 240px !important;
  height: 240px !important;
}
</style>